module.exports = __webpack_public_path__ + "img/hangyebanner.558f6920.png";